<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="form.valid && !form.pristine" [class.error]="!form.valid && !form.pristine">Payment Information</h2>
            </div>
            <div>
                <mat-icon *ngIf="form.pristine && !panelOpen" class="header-toggle">
                    expand_more
                </mat-icon>
                <mat-icon *ngIf="form.pristine && panelOpen" class="header-toggle">
                    expand_less
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && form.valid" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && !form.valid" class="header-toggle error">
                    close
                </mat-icon>
           </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="mx-2">
        <form [formGroup]="form">
            <div class="row">
                <div class="col-6 d-flex flex-column">
                    <mat-label>To whom should the check be made and sent? <span class="required-input">*</span></mat-label>
                    <mat-radio-group formControlName="send_check_to" (change)="handleOrganizationOrHomeownerChange($event)">
                        <mat-radio-button [value]="2">To Organization</mat-radio-button>
                        <mat-radio-button [value]="3" class="radio-button-margin-left">To Homeowner</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-6 d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker class="makeCheckPayableToInput">
                        <mat-label>Make Check Payable To <span class="required-input">*</span></mat-label>
                        <input matInput type="text" placeholder="Name" formControlName="send_check_to_name">
                        <mat-error *ngIf="form.controls['send_check_to_name'].invalid">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Phone Number <span class="required-input">*</span></mat-label>
                        <input type="text" matInput placeholder="555-123-4567" formControlName="send_check_to_phone" (input)="onPhoneNumberChange($event)">
                        <mat-error *ngIf="form.controls['send_check_to_phone'].invalid">Required | Ex: (XXX) XXX-XXXX</mat-error>
                        <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Email <span class="required-input">*</span></mat-label>
                        <input type="text" matInput placeholder="Email" formControlName="send_check_to_email">
                        <mat-error *ngIf="form.controls['send_check_to_email'].invalid">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div formGroupName="send_check_to_address">
                <div class="row justify-content-between mt-4">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Address Line 1 <span class="required-input">*</span></mat-label>
                            <input matInput type="text" placeholder="Address Line 1" formControlName="address_line_1">
                            <mat-error *ngIf="!form.get('address_line_1')?.invalid">Required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Address Line 2</mat-label>
                            <input matInput type="text" placeholder="Address Line 2" formControlName="address_line_2">
                            <mat-error *ngIf="!form.get('address_line_2')?.invalid">Invalid Input</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row justify-content-between mt-4">
                    <div class="col d-flex flex-column">
                        <mat-form-field class="full-width" appearance="outline" hideRequiredMarker>
                            <mat-label>Country <span class="required-input">*</span></mat-label>
                            <mat-select formControlName="country_id">
                                <mat-option *ngFor="let country of countries" [value]="country.id">{{ country.display_text }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="!form.get('country_id')?.invalid">Required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column" *ngIf="shouldShowStateInput(); else internationalProvince">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>State<span class="required-input">*</span></mat-label>
                            <mat-select formControlName="state">
                                <mat-option *ngFor="let state of states" [value]="state.value">{{ state.label }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="!form.get('state')?.invalid">Required</mat-error>
                        </mat-form-field>
                    </div>
                    <ng-template #internationalProvince>
                        <div class="col d-flex flex-column">
                            <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>State/Province <span class="required-input">*</span></mat-label>
                                <input matInput type="text" placeholder="Province" formControlName="state">
                                <mat-error *ngIf="!form.get('state')?.invalid">Required</mat-error>
                            </mat-form-field>
                        </div>
                    </ng-template>
                </div>
                <div class="row justify-content-between mt-4">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>City <span class="required-input">*</span></mat-label>
                            <input matInput type="text" placeholder="City" formControlName="city">
                            <mat-error *ngIf="!form.get('city')?.invalid">Required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Postal Code<span class="required-input">*</span></mat-label>
                            <input matInput type="text" placeholder="Postal Code" formControlName="postal_code">
                            <mat-error *ngIf="!form.get('postal_code')?.invalid">Required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <mat-action-row class="mt-5 d-flex flex-row align-content-center">
                <div class="d-flex align-items-center text-muted" style="margin-right: auto;">
                    <span class="required-input">*</span>&nbsp;- Required fields before submitting claim
                </div>
            </mat-action-row>
        </form>
    </div>
</mat-expansion-panel>